module.exports = __webpack_public_path__ + "img/ring_g_0_null_null@3x.600e72fe.png";